import React, { useState, lazy, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, Gift, Coffee, Check } from 'lucide-react';
export interface ProductProps {
  id: string;
  name: string;
  price: string;
  image: string;
  accentColor: string;
  base: string[];
  contains: string[];
  rotation: number;
}
export function ProductCard({
  product
}: {
  product: ProductProps;
}) {
  const [isExpanded, setIsExpanded] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 50
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className={`relative bg-white rounded-2xl p-4 md:p-6 shadow-polaroid flex flex-col h-full border border-stone-100 ${product.accentColor}`} style={{
    rotate: `${product.rotation}deg`
  }} whileHover={{
    rotate: 0,
    scale: 1.02,
    zIndex: 10,
    transition: {
      duration: 0.3
    }
  }} data-id="element-77">
      {/* Image Container */}
      <div className="relative aspect-[4/5] w-full overflow-hidden rounded-xl mb-6 bg-stone-100" data-id="element-78">
        <img src={product.image} alt={product.name} className="object-cover w-full h-full" loading="lazy" data-id="element-79" />
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full shadow-sm" data-id="element-80">
          <span className="font-serif font-bold text-lg text-stone-800" data-id="element-81">
            {product.price}
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="flex-grow flex flex-col" data-id="element-82">
        <h3 className="text-3xl font-serif text-stone-800 mb-2" data-id="element-83">
          {product.name}
        </h3>
        <p className="text-sm text-stone-500 mb-6 flex items-center" data-id="element-84">
          <Check className="w-4 h-4 mr-1 text-green-500" data-id="element-85" /> Reparto gratis radio
          urbano
        </p>

        <div className="space-y-4 mb-6 flex-grow" data-id="element-86">
          <div data-id="element-87">
            <h4 className="flex items-center text-sm font-bold uppercase tracking-wider text-stone-800 mb-2" data-id="element-88">
              <Gift className="w-4 h-4 mr-2 opacity-70" data-id="element-89" /> Base
            </h4>
            <ul className="text-sm text-stone-600 space-y-1 pl-6 list-disc marker:text-stone-300" data-id="element-90">
              {product.base.map((item, i) => <li key={i} data-id="element-91">{item}</li>)}
            </ul>
          </div>

          <div className="pt-2 border-t border-stone-100" data-id="element-92">
            <button onClick={() => setIsExpanded(!isExpanded)} className="flex items-center justify-between w-full text-left group" data-id="element-93">
              <h4 className="flex items-center text-sm font-bold uppercase tracking-wider text-stone-800" data-id="element-94">
                <Coffee className="w-4 h-4 mr-2 opacity-70" data-id="element-95" /> Contiene
              </h4>
              <ChevronDown className={`w-5 h-5 text-stone-400 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`} data-id="element-96" />
            </button>

            <AnimatePresence data-id="element-97">
              {isExpanded && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-98">
                  <ul className="text-sm text-stone-600 space-y-1.5 pl-6 pt-3 list-disc marker:text-stone-300" data-id="element-99">
                    {product.contains.map((item, i) => <li key={i} data-id="element-100">{item}</li>)}
                  </ul>
                </motion.div>}
            </AnimatePresence>
          </div>
        </div>

        {/* Action */}
        <a href={`https://wa.me/56941832127?text=${encodeURIComponent(`Hola, me gustaría el ${product.name} 💐`)}`} target="_blank" rel="noopener noreferrer" className="mt-auto w-full py-3.5 px-6 rounded-xl text-center font-medium transition-all duration-300 border-2 hover:bg-stone-800 hover:text-white hover:border-stone-800 border-stone-200 text-stone-700" data-id="element-101">
          Pedir por WhatsApp
        </a>
      </div>
    </motion.div>;
}